var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 4.65002V6.5H9.12C7.50999 6.5 6.70001 7.30998 6.70001 8.91998V18.5H4.15002C2.72002 18.5 2 17.78 2 16.35V4.65002C2 3.22002 2.72002 2.5 4.15002 2.5H8.45001C9.88001 2.5 10.6 3.22002 10.6 4.65002Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3699 8.91998V20.08C17.3699 21.69 16.57 22.5 14.96 22.5H9.11993C7.50993 22.5 6.69995 21.69 6.69995 20.08V8.91998C6.69995 7.30998 7.50993 6.5 9.11993 6.5H14.96C16.57 6.5 17.3699 7.30998 17.3699 8.91998Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.65002V16.35C22 17.78 21.28 18.5 19.85 18.5H17.37V8.91998C17.37 7.30998 16.57 6.5 14.96 6.5H13.4V4.65002C13.4 3.22002 14.12 2.5 15.55 2.5H19.85C21.28 2.5 22 3.22002 22 4.65002Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.25H10C9.59 12.25 9.25 11.91 9.25 11.5C9.25 11.09 9.59 10.75 10 10.75H14C14.41 10.75 14.75 11.09 14.75 11.5C14.75 11.91 14.41 12.25 14 12.25Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.25H10C9.59 15.25 9.25 14.91 9.25 14.5C9.25 14.09 9.59 13.75 10 13.75H14C14.41 13.75 14.75 14.09 14.75 14.5C14.75 14.91 14.41 15.25 14 15.25Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19.5V22.5H11.25V19.5C11.25 19.09 11.59 18.75 12 18.75C12.41 18.75 12.75 19.09 12.75 19.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5f3d15b7dee74948c58173b7ab91263f.svg";
export { ForwardRef as ReactComponent };